module.exports = __webpack_public_path__ + "img/student1.d5bd1497.png";